module.exports = __webpack_public_path__ + "static/img/wechat-screenshot.624a55e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/follow-modal/wechat-screenshot.png
// module id = r2U+
// module chunks = 4